import { render, staticRenderFns } from "./ObjectObstructionsEdit.vue?vue&type=template&id=55237d04&scoped=true"
import script from "./ObjectObstructionsEdit.vue?vue&type=script&lang=js"
export * from "./ObjectObstructionsEdit.vue?vue&type=script&lang=js"
import style0 from "./ObjectObstructionsEdit.vue?vue&type=style&index=0&id=55237d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55237d04",
  null
  
)

export default component.exports